import { fmtAUD, fmtCurrency } from '@/shared/utils/formatCurrency';

export default function BudgetOverview({
  expenseMap, currentBudgets, monthTxns,
  saveBudget, budgetMode, currency, theme, isDark,
}) {
  const t = theme;

  return (
    <>
      {Object.entries(expenseMap).map(([group, items]) => {
        if (!Array.isArray(items)) return null;
        const gB = items.reduce((z, c) => z + (Number(currentBudgets[c]) || 0), 0);
        const gA = items.reduce((z, c) => z + monthTxns.filter(tx => tx.category === c).reduce((zz, tx) => zz + (Number(tx.amount) || 0), 0), 0);
        const pct = gB > 0 ? Math.min(100, gA / gB * 100) : 0;
        const remaining = gB - gA;
        return (
          <div key={group} style={{ background: t.cardBg, borderRadius: 14, border: "1px solid " + t.cardBorder, padding: 0, marginBottom: 12, overflow: "hidden" }}>
            <div style={{ padding: "12px 20px", background: t.sectionBg, borderBottom: "1px solid " + t.cardBorder, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <span style={{ fontWeight: 700, color: t.text, fontSize: 14 }}>{String(group)}</span>
                <span style={{ marginLeft: 12, fontSize: 12, color: t.textMuted }}>
                  {budgetMode === "envelope"
                    ? (gB > 0 ? (remaining >= 0 ? currency + fmtAUD(remaining) + " left" : currency + fmtAUD(Math.abs(remaining)) + " overspent") : "No allocation")
                    : currency + fmtAUD(gA) + " of " + currency + fmtAUD(gB)}
                </span>
              </div>
              <div style={{ width: 130, background: isDark ? "#334155" : "#e2e8f0", borderRadius: 20, height: 6 }}>
                <div style={{ width: pct + "%", height: 6, borderRadius: 20, background: pct > 90 ? "#ef4444" : pct > 70 ? "#f59e0b" : "#22c55e", transition: "width 0.3s" }} />
              </div>
            </div>
            {items.map(cat => {
              const actual = monthTxns.filter(tx => tx.category === cat).reduce((z, tx) => z + (Number(tx.amount) || 0), 0);
              const b = Number(currentBudgets[cat]) || 0;
              return (
                <div key={cat} style={{ display: "flex", alignItems: "center", padding: "9px 20px", borderBottom: "1px solid " + t.cardBorder }}>
                  <span style={{ flex: 1, fontSize: 13, color: t.textSub }}>{String(cat)}</span>
                  <input type="number" value={currentBudgets[cat] || ""} placeholder="0" onChange={e => saveBudget(cat, e.target.value)} style={{ width: 80, textAlign: "right", border: "1px solid " + t.inputBorder, borderRadius: 6, padding: "4px 8px", fontSize: 12, marginRight: 14, outline: "none", background: t.inputBg, color: t.text }} />
                  <span style={{ width: 80, textAlign: "right", fontSize: 12, fontWeight: 600, color: actual > b && b > 0 ? "#ef4444" : t.textMuted }}>{currency + fmtAUD(actual)}</span>
                  <span style={{ width: 80, textAlign: "right", fontSize: 12, color: (b - actual) < 0 ? "#ef4444" : "#22c55e" }}>{b > 0 ? fmtCurrency(b - actual, currency) : "-"}</span>
                </div>
              );
            })}
          </div>
        );
      })}
    </>
  );
}
